/**
 * Phase 13 Metrics Dashboard — useDviComponentTrends
 *
 * Daily series for a single component+condition.
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TrendPoint {
  bucket_date: string;
  component_accuracy: number;
  severity_accuracy: number;
  recommendation_accuracy: number;
  total_samples: number;
  edit_rate: number;
  rejection_rate: number;
}

export function useDviComponentTrends(
  component: string | null,
  condition: string | null,
  rangeDays: number = 30,
) {
  return useQuery({
    queryKey: ['dvi-component-trends', component, condition, rangeDays],
    queryFn: async (): Promise<TrendPoint[]> => {
      if (!component || !condition) return [];
      const { data, error } = await supabase.rpc('get_dvi_component_confidence_trends', {
        p_component: component,
        p_condition: condition,
        p_range_days: rangeDays,
      });
      if (error) throw error;
      return (data ?? []) as TrendPoint[];
    },
    enabled: !!component && !!condition,
    staleTime: 60 * 1000,
  });
}
